import { DatePicker } from "jalali-react-datepicker";
import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

import * as Constants from "../../constants/urls";
import Loading from "../Loading/Loading";
import { useCookies } from "react-cookie";

const ExcelSellReport = () => {

    const [cookies, setCookie, removeCookie] = useCookies();
    const [loading, setLoading] = useState(0);
     const [end, setEnd] = useState(0);

    const [startDate, setStartDate] = useState(
        Math.round(new Date().getTime() / 1000),
    );
    const [endDate, setEndDate] = useState(
        Math.round(new Date().getTime() / 1000),
    );

    const endDateHandler = (value) => {
        let date = new Date(value).getTime() / 1000;
        setEndDate(date);
    };
    const startDateHandler = (value) => {
        let date = new Date(value).getTime() / 1000;
        setStartDate(date);
    };
    const dataExport = () => {
 
        setLoading(true);
        const url = Constants.apiUrl + "/api/excel/sell-report";
        axios
            .post(url, {
                from: startDate,
                to: endDate,
            }, {
                headers: {
                    Authorization: "Bearer " + cookies.user_server_token,
                },
                responseType: 'arraybuffer',
            })
            .then((response) => {
               
    setLoading(false);
    setEnd(true);
            }) 
            .catch((e) => {
                setLoading(false);
                console.log(e);
            });

    }

    return (
        <>
            {loading ? <Loading /> : ""}

            <div className="text-center bg-primary text-white py-4">
                <strong>
                    گزارش فروش محصولات
                </strong>
            </div>
            <div style={{ display: "flex", alignItems: "center", background: "url('" + Constants.watermarkUrl + "')", backgroundRepeat: "no-repeat", minHeight: "90vh", backgroundPosition: "center", backgroundColor: "#fff" }}>
                <div className="container" >
                    <div className="bg-white  rounded shadow p-5" style={{ opacity: "0.9" }}>

                        <div className="row">
                            <div className="col-6  text-right">
                                <label>تاریخ پایان</label>

                                <DatePicker
                                    className={["form-control"].join(" ")}
                                    style={{ direction: "rtl" }}
                                    timePicker={true}
                                    value={endDate * 1000}
                                    isRenderingButtons={false}
                                    onClickSubmitButton={(value) => {

                                        endDateHandler(value.value._d);
                                        console.log(endDate);
                                        
                                    }}
                                />
                            </div>

                            <div className="col-6 text-right">
                                <label>تاریخ شروع</label>
                                <DatePicker
                                    className={["form-control"].join(" ")}
                                    style={{ direction: "rtl" }}
                                    timePicker={true}
                                    value={startDate * 1000}

                                    onClickSubmitButton={(value) => {
                                        startDateHandler(value.value._d);
                                        console.log(startDate);

                                    }}
                                />
                            </div>
                        </div>
                        <div className="row my-4">
                            <button
                                className="btn btn-danger btn-block "
                                onClick={dataExport}
                            >
                                خروجی
                            </button>
                            {end?
        <div className="alert alert-success w-100 mt-4 text-center">
                                گزارش با موفقیت در صف خروجی ها قرار گرفت از <Link to={"/admin/excel/index"}><strong className="text-danger">اینجا</strong> </Link>میتوانید گزارش را پیگیری و پس از تکمیل دریافت کنید 
                            </div>
                            :""}
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}
export default ExcelSellReport;
